// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"120":"2ed217bbb406f6023ab1","197":"2ed217bbb406f6023ab1","492":"2ed217bbb406f6023ab1"}[chunkId] + ".css";
};